<template>
    <transition appear name="fade-transition">
        <div :class="classList">
            <v-text-field
                ref="input"
                v-model="inputValue"
                v-mask="maskValue"
                v-test-id
                class="edit__date__input"
                :name="name || uuid"
                type="text"
                outlined
                dense
                :rules="validators"
                :label="label"
                :hint="hint"
                :description="description"
                :placeholder="placeholder"
                persistent-placeholder
                background-color="background"
                color="primaryText"
                :hide-details="hideDetails !== null ? hideDetails : !form && _.isEmpty(validators) ? true : false"
                :disabled="disabled"
                :loading="loading"
                :readonly="readonly"
                :autocomplete="'off'"
                :error="error"
                :error-messages="errorMessages"
                :min="min"
                :max="max"
                @blur="$event => $emit('blur', $event, inputValue)"
                @focus="$event => $emit('focus', $event, inputValue)"
                @keyup="$event => $emit('keyup', $event, inputValue)"
                @keydown="$event => $emit('keydown', $event, inputValue)"
                @click="$event => $emit('click', $event, inputValue)"
            >
                <template #append>
                    <slot name="append" />

                    <app-tooltip v-if="info || findSlot('info')" :value="info">
                        <v-icon dense small color="info" style="margin-bottom: 0.1rem">{{
                            getIcon('info', 'fad')
                        }}</v-icon>
                        <template v-if="findSlot('info')" #display>
                            <slot name="info" />
                        </template>
                    </app-tooltip>

                    <app-button
                        v-if="clearable && !readonly && !disabled && !required && inputValue"
                        :icon="getIcon('clear', 'far')"
                        class="ml-2"
                        small
                        icon-size="1.4em"
                        @click="inputValue = null"
                    />
                </template>
            </v-text-field>
        </div>
    </transition>
</template>

<script>
import Edit from './Edit';
import toDatetime from '@/lib/helpers/toDatetime';

export default {
    name: 'EditDate',
    extends: Edit,
    props: {
        min: {
            type: String,
            default: null
        },
        max: {
            type: String,
            default: null
        }
    },
    computed: {
        inputValue: {
            get() {
                try {
                    return toDatetime(this.value, 'DD/MM/YYYY');
                } catch (error) {
                    return this.value;
                }
            },
            set(value) {
                if (value && typeof value == 'string') {
                    const lengths = value.split('-').map(part => {
                        part = part.replace(' ', '');
                        return /^\d+$/.test(part) ? part.length : 0;
                    });

                    if ([4, 2, 2].every((l, i) => l === lengths[`${i}`])) {
                        this.$emit('input', value);
                    }
                } else {
                    this.$emit('input', null);
                }
            }
        },
        maskValue() {
            if (this.mask) {
                return this._.isFunction(this.mask) ? this.mask() : this.mask;
            }

            return this.getMask('date', {
                prefix: this.prefixValue,
                suffix: this.suffixValue
            });
        }
    }
};
</script>

<style lang="scss">
.edit__date {
    min-width: 7rem;
}
</style>
